import React  from "react";
import { useParams } from 'react-router-dom';
import JobRoleRequestForm from "./components/JobRoleRequestForm";
import Card from "components/card";

const ViewJobRoleRequest = () => {

	const { requestId } = useParams();
    
	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
				<Card extra={"w-full h-full p-4"}>
					<JobRoleRequestForm recordId={requestId} mode="view"/>
				</Card>
	      	</div>
	    </div>
    );
};

export default ViewJobRoleRequest;